<template>
  <div class="mx-sm-1 mt-0">
    <div class="page-header">
      <h1 class="page-title fw-bold">Type de document</h1>
    </div>
    <DocumentTypeForm createMode />
  </div>
</template>

<script>
  import DocumentTypeForm from './DocumentTypeForm.vue';

  export default {
    name: 'DocumentTypeCreate',
    components: { DocumentTypeForm },
  };
</script>
